import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center; 
  background-color: #fff;
  margin-top: 20px;
`;

export const CommentForm = styled.form`
  display: flex;
  width: 50vw;
  min-width: 350px;
  height: auto;
  justify-content: space-between;
  border: ${({ withFocus }) => (withFocus ? '1px solid #F07E31' : '1px solid #CBCBCB')} ;
  border-radius: 4px;
  padding: 12px 16px 12px 16px;
  background: #FFFFFF;
  margin-bottom: 43px;  
`;

export const CommentInput = styled.textarea`
  border: none;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  width: 91%;
  resize: none;
  height: ${({ heightForm }) => heightForm}px;
  overflow: hidden;

  ::placeholder {
    color: #CBCBCB;
  }
`;

export const SendButton = styled.button`
  outline: none;
  border: none;
  background: #fff;
  color: #F07E31;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;

  :focus {  
    outline: 0 !important;
  }

  :active {
    opacity: 0.7;
  }
`;

export const WrapperComments = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 50vw;
  justify-content: center;
  align-items: center;

  > div:nth-child(even){
    background-color: #fbfbfb;
  }
`;

export const TypeActivity = styled.div`
  width: 40px;
`;

export const ContainerComment = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  border-bottom: 2px solid #EEEEEE;
  padding: 16px 23px 16px 23px;
`;

export const ContentComments = styled.div`
  display: flex;
  flex: 1;
  margin: 16px 0px 18px 18px;

  p{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    ${({ isComment }) => (isComment ? 'font-size: 14px' : 'font-size: 16px')};
    line-height: 20px;
    margin: 0;
    word-wrap:break-word;
    width: 100%;
    white-space: normal
  }
`;

export const UserComment = styled.div`
  display: flex;
  margin-left: 15px;

  img {
    width: 25px;
    height: 25px;
    border-radius: 50%;
  }

  h4{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-size: 14px;
    line-height: 20px;
    color: #565656;
    width: 125px;
    margin: 0px 24px 0px 12px;
  }  

  span{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    margin-top: 2px;
    color: #CBCBCB;
  }
`;
